import { render, staticRenderFns } from "./ConfigRetries.vue?vue&type=template&id=6a37a7f3&scoped=true&"
import script from "./ConfigRetries.vue?vue&type=script&lang=js&"
export * from "./ConfigRetries.vue?vue&type=script&lang=js&"
import style0 from "./ConfigRetries.vue?vue&type=style&index=0&id=6a37a7f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a37a7f3",
  null
  
)

export default component.exports